import PropTypes from 'prop-types';

import { DSIcon } from '@spotahome/ui-library/base';

const PropertyDescriptionItem = ({ value, text, iconName = '' }) => (
  <div>
    {iconName && (
      <span aria-hidden="true">
        <DSIcon name={iconName} className="property-title__icon" />
      </span>
    )}
    <strong>{value}</strong> {text}
  </div>
);

PropertyDescriptionItem.propTypes = {
  value: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string
};

export default PropertyDescriptionItem;
